export const CLIENT_TAXONOMY_COLLECTION_KEY_PATTERN = /^[a-z][a-z0-9]*(?:_[a-z0-9]+)*$/;
export const CLIENT_TAXONOMY_COLLECTION_KEY_MAX_LENGTH = 64;

export const isValidClientTaxonomyCollectionKey = (value: unknown): value is string => {
    return (
        typeof value === 'string' &&
        value.length <= CLIENT_TAXONOMY_COLLECTION_KEY_MAX_LENGTH &&
        CLIENT_TAXONOMY_COLLECTION_KEY_PATTERN.test(value)
    );
};
